import styled from 'styled-components';
import { IOverlayStyles } from './types';

export const Overlay = styled.div<IOverlayStyles>`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  flex: 1;
`;
export const Background = styled.div`
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

export const ModalContent = styled.div`
  display: flex;
  background: #fff;
  padding: 10px;
  border-radius: 12px;
  gap: 20px;
  position: relative;
  position: fixed;
  justify-content: space-between;
  max-width: 1000px;
`;
